export interface Flavor {
  outOfStock?: boolean;
  variant?: {
    variants?: {
      availableForSale?: boolean;
    }[];
  };
}
/**
 * Determines if a flavor is out of stock.
 * - `outOfStock` is manually set in Sanity (e.g. via radio).
 * - `availableForSale` comes from Shopify and reflects live purchasability.
 * - Ignores `currentlyNotInStock` as it’s fulfillment-based and unreliable.
 */
export function isFlavorOutOfStock(flavor: Flavor): boolean {
  const isManuallyOutOfStock = flavor.outOfStock === true;
  const isShopifyUnavailable = flavor.variant?.variants?.[0]?.availableForSale === false;

  return isManuallyOutOfStock || isShopifyUnavailable;
}
